/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import jobObj from '../../../objects/jobObj.js';
import jobUtil from '../../../objects/jobUtil.js';
import ko from 'knockout';
//import _ from 'lodash';
import moment from 'moment';
//import axios from 'axios';
import $ from 'jquery';

import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';

class jobViewModel {

    constructor() {

        // Profile
        this.componentName = "jobHistoryModel";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.jobVersion = ko.observable({data:""});
        this.jobVersionDate = ko.observable(null);

        this.context.eventManager.subscribe((viewJobObject) =>{
            this.displayJob(viewJobObject);
        },this, "viewJobVersion");


    }

    displayJob(viewJobObject) {
        this.jobVersion(viewJobObject);
        this.jobVersionDate(moment(viewJobObject.createdate).format('lll'));
        $('#jobViewModal').modal('show');
    }

    revertJobConfirm() {

        console.log('job-view:clickDeleteConfirm');

        let self = this;

        BootstrapDialog.confirm({
            
            title: 'Job Version Action',
            message: 'Are you sure you want make this version current?', 
            
            callback: function(result){

            if(result) {
                console.log('job-view:clickDeleteConfirm result %o', result);
                self.revertJob(self.jobVersion);
                } 
            }

        });

    }

    revertJob(jobVersion) {

        console.log('job-view:revertJob:  jobid: %o  jobVersion: %o', jobVersion().jobid,jobVersion().id );

        let jobUtilObj = new jobUtil(this.context);

        jobUtilObj.revertToJobVersion({jobid:jobVersion().jobid, jobVersionid:jobVersion().id}).then(
            result => {
                console.log('job-view::revertJob result %o', result);
                this.context.eventManager.notifySubscribers(null,"jobHistoryRefresh");
                $('#jobViewModal').modal('hide');
            }
        ).catch( error => {
            console.log('job-view:revertJob Error %o', error);
        });

    }

    closeModal() {
        this.jobVersion(null);
    }



}

export default { viewModel: jobViewModel, template: require('!raw-loader!./job-view.html') };


// WEBPACK FOOTER //
// ./src/components/nav-job-list/job-view/job-view.js